"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"];
//# sourceMappingURL=circle.js.map